<template>
  <div class="showtimes-calendar">
    <div class="row" style="margin-top: 10px" v-if="resourceSelector || productSelector">
      <div class="col-sm-5 col-md-4 col-lg-3 filtercol" v-if="resourceSelector">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-addon"><i class="fa fa-fw fa-cube"></i> {{ _('Resource') }}</div>
            <select class="form-control" id="resourceFilter" v-model="selectedTheater">
              <option value="">{{ _('Select...') }}</option>
              <option v-for="theater in theaters" :value="theater.id">{{ theater.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5 col-md-4 col-lg-3 filtercol" v-if="productSelector">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-addon"><i class="fa fa-fw fa-cubes"></i> {{ _('Product') }}</div>
            <select class="form-control" id="productFilter" v-model="selectedMovie">
              <option value="">{{ _('Select...') }}</option>
              <option v-for="movie in movies" :value="movie.id">{{ movie.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-2 col-md-4 col-lg-6" v-if="false && isFloatingReceiptAvailable">
        <button class="pull-right newSelector btn btn-success addbutton" type="button" v-on:click="newOrder"><i class="fa fa-fw fa-plus"></i> {{ _('Create new...') }}</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <template v-if="settings">
          <CalendarView v-if="useNewScheduler" :column="column" :url="dataUrl" :shopId="shopId" :locale="locale" :reloadEvents="reloadEvents" :productFilter="selectedMovie"  :initialWeekStart="resolvedInitialWeekStart" :resourceFilter="selectedTheater" v-on:eventClicked="eventClicked" v-on:capacityClicked="capacityClicked" v-on:eventDragged="eventDragged" />
          <Calendar v-else :column="column" :url="dataUrl" :shopId="shopId" :locale="locale" :reloadEvents="reloadEvents" :productFilter="selectedMovie"  :initialWeekStart="resolvedInitialWeekStart" :resourceFilter="selectedTheater" v-on:eventClicked="eventClicked" v-on:capacityClicked="capacityClicked" v-on:eventDragged="eventDragged" />
        </template>
      </div>
    </div>
    <seat-map :column="column" ref="seatMap" :showButtons="true" borderRadius="20" :show="activeShow" :seatMap="seatMap" v-if="showSeatMap" v-on:confirmSelection="closeSeatMap" v-on:closeModal="closeSeatMap"></seat-map>
  </div>
</template>

<script>

import axios from 'axios'
import { DateTime } from 'luxon'
import components from '~/lib/components'
import settingshelpers from '~/lib/settingshelpers'
import { mapGetters } from 'vuex'
import { Calendar, CalendarView, ShowEditor, SeatMap } from '#components'

export default {
  data () {
    return {
      theaters: [],
      movies: [],
      currEvent: null,
      isExisting: false,
      shouldDelete: false,
      modalClosed: false,
      pendingCalendarReload: false,
      reloadEvents: ['showUpdate', 'availabilityUpdate', 'showEditorUpdate'],
      showSeatMap: false,
      activeShow: null,
      seatMap: null,
      selectedTheater: '',
      selectedMovie: ''
    }
  },
  mixins: [components, settingshelpers],
  props: ['column', 'resourceSelector', 'productSelector', 'product', 'initialWeekStart'],
  computed: {
    ...mapGetters(['locale', 'user', 'pos']),
    dataUrl () {
      return this.baseDomain + this.shopId + '/showschedule.json?apikey=' + this.apiKey
    },
    shortLocale () {
      return this.locale.split('_')[0]
    },
    useNewScheduler () {
      return this.isFeatureEnabled('scheduler2.0')
    },
    resolvedInitialWeekStart () {
      if (typeof this.initialWeekStart !== 'undefined') {
        return this.initialWeekStart
      }
      if (this.product && this.product.displayedtype === 'movie') {
        return 5
      }
      return 1
    }
  },
  methods: {
    emitCalendarReload () {
      this.pendingCalendarReload = false
      this.EventBus.$emit('showEditorUpdate', {
        data: true,
        shopId: this.shopId
      })
    },
    scheduleCalendarReload () {
      this.pendingCalendarReload = true
      if (this.modalClosed) {
        this.emitCalendarReload()
      }
    },
    newOrder () {
      this.EventBus.$emit('showFloatingReceipt')
    },
    closeSeatMap () {
      this.activeShow = null
      this.seatMap = null
      this.showSeatMap = false
    },
    eventClicked (event, isExisting, deleteHandler) {
      this.editShow(event, isExisting, deleteHandler);
    },
    async capacityClicked (event) {
      if (!parseInt(event.showseatmap) || !parseInt(event.resource_id)) {
        return
      }
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/shows/' + event.id + '.json?details=true')
      } catch(e) {
        return
      }
      this.activeShow = response.data
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resources/' + event.resource_id + '/seatmaps.json?start_ts=' + DateTime.fromJSDate(event.start_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger() + '&end_ts=' + DateTime.fromJSDate(event.end_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger())
      } catch(e) {
        return
      }
      this.seatMap = response.data
      this.showSeatMap = true
    },
    eventDragged (event, restoreHandler) {
      let data = {
        id: event.id,
        start_ts: DateTime.fromJSDate(event.start_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger(),
        end_ts: DateTime.fromJSDate(event.end_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger(),
      }
      this.showDialog({
        title: this._('Do you want to save the change you made to this show?'),
        buttons: [
          {
            title: this._('Save'),
            class: 'success',
            icon: 'save',
            handler: () => {
              this.saveEventTime(data, restoreHandler)
            }
          }, 
          {
            title: this._('Cancel'),
            icon: 'undo',
            handler: () => {
              restoreHandler()
            }
          }
        ]
      })
    },
    async editShow (event, isExisting, deleteHandler) {
      const $this = this
      if (isExisting) {
        this.isExisting = true
      } else {
        this.isExisting = false
        if (this.selectedMovie) {
          event.product_id = this.selectedMovie
          event.text = this.getMovieName(this.selectedMovie)
        }
        event.resource_id = null
      }
      this.shouldDelete = false
      this.modalClosed = false
      this.pendingCalendarReload = false
      this.currEvent = event
      this.showModal('showeditor', ShowEditor, {
        props: {
          sourceEvent: event, 
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          shortLocale: this.shortLocale,
          apiKey: this.apiKey,
          defaultPricing: this.product ? this.product.pricing_id : null,
          product: this.product
        },
        events: {
          deleteEvent: this.deleteEvent,
          saveEvent: this.saveEvent
        },
        handlers: {
          closed: (e) => {
            this.modalClosed = true
            if (deleteHandler && (this.shouldDelete || !this.isExisting)) {
              deleteHandler(event)
            }
            if (this.pendingCalendarReload) {
              this.emitCalendarReload()
            }
          }
        },
        width: 800
      })
    },
    getMovieName(productId) {
      if (this.product && this.product.id === productId) {
        return this.product.name
      }
      for (let i = 0; i < this.movies.length; i++) {
        if (this.movies[i].id === productId) {
          return this.movies[i].name
        }
      }
      return ''
    },
    async saveEventTime (data, restoreHandler) {
      let response
      try {
        response = await axios.patch(this.baseDomain + this.shopId + '/shows/' + data.id + '.json?apikey=' + this.apiKey, data)
      } catch (e) {
        restoreHandler()
        return this.showError(e)
      }
    },
    async saveEvent (event) {
      this.shouldDelete = true
      let eventData = {
        'start_ts': DateTime.fromJSDate(event.start_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger(),
        'end_ts': DateTime.fromJSDate(event.end_date).setZone(this.timezone, { keepLocalTime: true }).toUnixInteger(),
        'upcoming': event.upcoming,
        'showseatmap': event.showseatmap,
        'product_id': event.product_id,
        'resource_id': event.resource_id,
        'pricing_id': event.pricing_id,
        'hideinternet': event.hideinternet,
        'hidepos': event.hidepos
      }
      if (Array.isArray(event.labelIds)) {
        eventData.labels = event.labelIds
      }
      if (this.isExisting) {
        eventData.id = this.currEvent.id
      }
      let dates = event.dates
      if (!dates || !dates.length) {
        dates = [{ 
          start_ts: eventData.start_ts, 
          end_ts: eventData.end_ts
        }]
      }
      for (var i = 0; i < dates.length; i++) {
        eventData.start_ts = dates[i].start_ts
        eventData.end_ts = dates[i].end_ts
        let response
        try {
          if (this.isExisting) {
            response = await axios.put(this.baseDomain + this.shopId + '/shows/' + eventData.id + '.json?apikey=' + this.apiKey, eventData)
          } else {
            response = await axios.post(this.baseDomain + this.shopId + '/shows.json?apikey=' + this.apiKey, eventData)
          }
        } catch (e) {
          // Trigger a manual reload of the calendar because the delete handler will have removed the event, even though the operation failed
          this.scheduleCalendarReload()
          return this.showError(e)
        }
      }
      this.scheduleCalendarReload()
    },
    async deleteEvent (event) {
      this.shouldDelete = true
      if (this.isExisting) {
        let response
        try {
          response = await axios.delete(this.baseDomain + this.shopId + '/shows/' + event.id + '.json?apikey=' + this.apiKey, { id: event.id })
        } catch(e) {
          // Trigger a manual reload of the calendar because the delete handler will have removed the event, even though the operation failed
          this.scheduleCalendarReload()
          return this.showError(e)
        }
      } else {
        // Do nothing
      }
    },
    async loadTheaters () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/resources.json?sSearch_2=theater&apikey=' + this.apiKey)
      } catch (e) {
        return
      }
      this.theaters = response.data.map(r => ({ id: r.id, name: r.name })).sort((a, b) => a.name > b.name ? 1 : -1)
    },
    async loadMovies () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/' + this.locale + '/products.json?sSearch_3=1-4-all&iSortingCols=1&iSortCol_0=2&sSortDir_0=asc&simple=true&apikey=' + this.apiKey)
      } catch (e) {
        return
      }
      this.movies = response.data.map(r => ({ id: r.id, name: r.name }))
    }
  },
  components: {
    Calendar,
    CalendarView,
    ShowEditor,
    SeatMap
  },
  created () {
    if (this.product) {
      this.selectedMovie = this.product.id
    }
  },
  mounted () {
    if (this.resourceSelector) {
      this.loadTheaters()
    }
    if (this.productSelector) {
      this.loadMovies()
    }
    /*
    if(!this.events) {
      let events = {}
      events['showUpdate'] = (message) => {
        if (message && message.data && message.shopId === this.shopId) {
          return this.reload()
        }
      }
      this.events = events
    }
    this.enableEventBus()
    */
  }
}

</script>
